import { create } from 'zustand';
import { ExecutiveDashboard, ExecutiveWidget } from '../types';

interface EditModeState {
  isEditing: boolean;
  draftDashboard: ExecutiveDashboard | null;
  removedWidgetIds: string[];
  hasChanges: boolean;
  enterEditMode: (dashboard: ExecutiveDashboard) => void;
  cancelEdit: () => void;
  markWidgetForRemoval: (widgetId: string) => void;
  undoWidgetRemoval: (widgetId: string, originalDashboard: ExecutiveDashboard) => void;
  addDuplicatedWidget: (newWidget: ExecutiveWidget) => void;
}

export const useEditModeStore = create<EditModeState>((set) => ({
  isEditing: false,
  draftDashboard: null,
  removedWidgetIds: [],
  hasChanges: false,
  enterEditMode: (dashboard) =>
    set({
      isEditing: true,
      draftDashboard: JSON.parse(JSON.stringify(dashboard)),
      removedWidgetIds: [],
      hasChanges: false,
    }),
  cancelEdit: () =>
    set({
      isEditing: false,
      draftDashboard: null,
      removedWidgetIds: [],
      hasChanges: false,
    }),
  markWidgetForRemoval: (widgetId) =>
    set((state) => {
      if (!state.draftDashboard) return state;
      return {
        ...state,
        draftDashboard: {
          ...state.draftDashboard,
          widgets: state.draftDashboard.widgets.filter((w) => w.id !== widgetId),
        },
        removedWidgetIds: [...state.removedWidgetIds, widgetId],
        hasChanges: true,
      };
    }),
  undoWidgetRemoval: (widgetId, originalDashboard) =>
    set((state) => {
      if (!state.draftDashboard) return state;
      const originalWidget = originalDashboard.widgets.find((w) => w.id === widgetId);
      if (!originalWidget) return state;
      return {
        ...state,
        draftDashboard: {
          ...state.draftDashboard,
          widgets: [...state.draftDashboard.widgets, originalWidget],
        },
        removedWidgetIds: state.removedWidgetIds.filter((id) => id !== widgetId),
        hasChanges: state.removedWidgetIds.length > 1,
      };
    }),
  addDuplicatedWidget: (newWidget) =>
    set((state) => {
      if (!state.draftDashboard) return state;
      return {
        ...state,
        draftDashboard: {
          ...state.draftDashboard,
          widgets: [...state.draftDashboard.widgets, newWidget],
        },
        hasChanges: true,
      };
    }),
}));
